import { render, staticRenderFns } from "./FilterItem.desktop.component.vue?vue&type=template&id=687ea8da&scoped=true&"
import script from "./FilterItem.desktop.component.vue?vue&type=script&lang=js&"
export * from "./FilterItem.desktop.component.vue?vue&type=script&lang=js&"
import style0 from "./FilterItem.desktop.component.vue?vue&type=style&index=0&id=687ea8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687ea8da",
  null
  
)

export default component.exports